import { t } from 'i18next';
import * as yup from 'yup';

import { usePostWithdrawalsRequest } from 'services/hooks/withdrawal';
import { formatKoreanNumber } from 'utils/number/formatKoreanNumber';
import { translation } from 'utils/translation';

import AvailableModal from './AvailableModal';

export interface ChangeBubbleData {
  minAmount: number;
  maxAmount: number;
  goodsUnit: number;
}

export const withdrawalSchema = (data: ChangeBubbleData) =>
  yup.object({
    withdrawalAmount: yup
      .number()
      .typeError('전환 금액은 숫자만 입력하세요.')
      .required('전환액을 입력해주세요')
      .test('is-non-zero', `${t('chat.rewards_convert_bubbles_alert_units')}`, (value) => !!value && value !== 0)
      .test(
        'max-amount-validation',
        `${t('chat.rewards_convert_bubbles_alert_limit')}`,
        (value) => !!value && value <= data.maxAmount
      )
      .test('is-multiple-of-goodsUnit', `${t('chat.rewards_convert_bubbles_alert_units')}`, (value) => {
        return !!value && value % data.goodsUnit === 0;
      })
      .test(
        'min-amount',
        `${t('chat.rewards_convert_bubbles_alert_units')}`,
        (value) => !!value && value >= data.minAmount
      ),
  });

const AvailableChangeBubbleModal = () => {
  const { mutateAsync: postWithdrawal, isPending: isProcessWithdrawal } = usePostWithdrawalsRequest();
  const postWithdrawalRequest = async (afterTaxAmount: number) => {
    await postWithdrawal({
      afterTaxAmount,
      type: 'bubble-reward',
    });
  };

  return (
    <AvailableModal withdrawalSchema={withdrawalSchema} goodsUnit={1000} type="bubble">
      <AvailableModal.Header title={translation('chat.rewards_convert_bubbles_modal_title')} />
      <AvailableModal.Body
        availableGoodsText={translation('chat.rewards_convertible_bubbles')}
        requestedGoodsText={translation('chat.rewards_bubbles_to_convert')}
        units={[t('chat.rewards_currency_bubbles_zero'), t('chat.rewards_currency_bubbles_other')]}
        GuideLineListComponent={
          <ul>
            <li>
              <p className="text emphasize">{translation('chat.rewards_convert_bubbles_description_calculated')}</p>
            </li>
            <li>
              <p className="text emphasize">{translation('chat.rewards_convert_bubbles_description_refund')}</p>
            </li>
            <li>
              <p className="text">{translation('chat.rewards_convert_bubbles_description_units')}</p>
            </li>
            <li>
              <p className="text">{translation('chat.rewards_confirmation_email')}</p>
            </li>
          </ul>
        }
      />
      <AvailableModal.Footer
        isProcessWithdrawal={isProcessWithdrawal}
        postWithdrawalRequest={postWithdrawalRequest}
        withdrawalSuccessToastText="전환 신청이 완료되었습니다."
        withdrawalFailureToastText="전환 신청이 실패했습니다."
      />
    </AvailableModal>
  );
};

export default AvailableChangeBubbleModal;
